import { Dialog } from '@headlessui/react'
import { IKImage } from 'imagekitio-react'
import React from 'react'
import { useSelector } from 'react-redux'

const ActivationModal = ({isModalEnabled , setIsModalEnabled}) => {

    const first_name = useSelector(store=> store?.profileDetails?.first_name)

    const features = [ 'Unlimited Free Courses' , '1st Certificate for Free' , 'Learning Inside WhatsApp' , 'Access to all Live Webinars' , '1 Mega-Competition Access' , '1 Placement Support Workshop' , 'Move to free plan anytime']
  return (
    <Dialog
    open={isModalEnabled}
    onClose={() => null}
    as="div"
    style={{ zIndex: "9999999999" }}
    className="fixed inset-0 z-10 -mt-10 flex flex-col items-center justify-center overflow-y-auto md:mt-10 md:justify-start"
  >
    <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
    <Dialog.Title />
    <Dialog.Description />
    <div className="relative z-10 flex  w-11/12 flex-col items-center justify-center overflow-auto rounded-xl bg-white py-4 px-6 text-center shadow-2xl  md:w-1/4 md:p-4 lg:w-1/4">
    <img
        urlEndpoint="https://assets.learntube.ai/files/"
        src={"https://assets.learntube.ai/files/Content_player/important.svg?updatedAt=1679552184642"}
        transformation={[{
            "height": "110",
            "width": "110",
        }]}
        className=""
    />
      <div className='text-xl font-bold mt-2'>Let’s build your dream career </div>
      <div className='text-xl font-bold'>{first_name}!</div>
      <div className='text-center text-md  leading-tight font-medium mt-2'>Complete the quiz to unlock free 7 day trial of our best <span className='font-bold'>LearnTube Max plan.</span></div>
      <div className='text-start self-start text-md  leading-tight font-bold mt-2'>As part of this trial you get:</div>
      <div className='self-start mt-2'>
        {
            features?.map((item, index) => 
            <div className='flex justify-start items-center mt-2'>
                <img
                    urlEndpoint="https://assets.learntube.ai/files/"
                    src={"https://assets.learntube.ai/files/PRICING/img10.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658938810160"}
                    transformation={[{
                    "height": "160",
                    "width": "160",
                    }]}
                    className=" "

                />
                <div className='ml-2 font-medium'>{item}</div>
            </div>)
        }
      </div>
      <button className='bg-[#13B284] mt-4 text-white px-4 py-2 rounded-lg' onClick={(e)=> setIsModalEnabled(false)}>Start Learning</button>
    </div>
  </Dialog>
  )
}

export default ActivationModal
